"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownNav = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _pageLink = require("../page-link");

var _helpers = require("../../helpers");

var _jsxFileName = "D:\\DXC\\Digital.UI.CommonStyling\\src\\lib\\components\\header\\dropdown-nav.jsx";

/**
 * Component for navigation dropdown elemnt used in
 * mobile view of Header component.
 */
const DropdownNav = props => {
  var _props$header, _props$header2, _props$header3, _props$header4, _props$SearchForm, _props$header5, _props$header6, _props$header7;

  const [thirdLevelToShow, setThirdLevelToShow] = (0, _react.useState)('');
  const [fourthLevelToShow, setFourthLevelToShow] = (0, _react.useState)('');

  const navLink = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-nav__primary-link-ctn",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 13
      }
    }, props.linkGroupList && props.linkGroupList.length && props.linkGroupList.map((data, index) => {
      return data.linkList.map(value => {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "dropdown-nav__primary-link-unit",
          key: value.label,
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 20,
            columnNumber: 29
          }
        }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
          to: value.path,
          key: value.label,
          className: "dropdown-nav__primary-nav-link",
          label: value.label,
          target: value.target,
          onClick: e => {
            var _props$trackClick;

            return props === null || props === void 0 ? void 0 : (_props$trackClick = props.trackClick) === null || _props$trackClick === void 0 ? void 0 : _props$trackClick.call(props, e);
          },
          onAuxClick: e => {
            var _props$trackClick2;

            return props === null || props === void 0 ? void 0 : (_props$trackClick2 = props.trackClick) === null || _props$trackClick2 === void 0 ? void 0 : _props$trackClick2.call(props, e);
          },
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21,
            columnNumber: 33
          }
        }, value.label));
      });
    }));
  };

  const isAuthMenu = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-nav__primary-link-ctn",
      style: {
        marginBottom: '52px'
      },
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 13
      }
    }, props.isAuthenicatedMenu.map(value => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-nav__primary-link-unit",
        key: value.label,
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 25
        }
      }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
        to: value.path,
        key: value.label,
        className: "dropdown-nav__primary-nav-link",
        label: value.label,
        target: value.target,
        onClick: e => {
          var _props$trackClick3;

          return props === null || props === void 0 ? void 0 : (_props$trackClick3 = props.trackClick) === null || _props$trackClick3 === void 0 ? void 0 : _props$trackClick3.call(props, e);
        },
        onAuxClick: e => {
          var _props$trackClick4;

          return props === null || props === void 0 ? void 0 : (_props$trackClick4 = props.trackClick) === null || _props$trackClick4 === void 0 ? void 0 : _props$trackClick4.call(props, e);
        },
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46,
          columnNumber: 29
        }
      }, value.label));
    }));
  };

  function generateThird(items, expandThirdId) {
    let array = [];
    items.children.forEach((linkitem, thirdLvlIndex) => {
      var _linkitem$children;

      const expandFourthId = `${expandThirdId}-${thirdLvlIndex}-${linkitem.title}`;
      const fourthLevelClass = (0, _classnames.default)('secondary-dropdown-nav__submenu secondary-dropdown-nav__submenu-fourth', {
        'secondary-dropdown-nav__submenu secondary-dropdown-nav__submenu-fourth--active': expandFourthId === fourthLevelToShow
      });

      function show() {
        setFourthLevelToShow(expandFourthId);
      }

      function hide() {
        setFourthLevelToShow('');
      }

      array.push( /*#__PURE__*/_react.default.createElement("li", {
        key: thirdLvlIndex,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "secondary-dropdown-nav__submenu__link",
        "aria-label": linkitem === null || linkitem === void 0 ? void 0 : linkitem.title,
        href: linkitem === null || linkitem === void 0 ? void 0 : linkitem.url,
        target: linkitem === null || linkitem === void 0 ? void 0 : linkitem.target,
        onClick: show,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "secondary-dropdown-nav__submenu__link-text",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89,
          columnNumber: 25
        }
      }, linkitem === null || linkitem === void 0 ? void 0 : linkitem.title)), (linkitem === null || linkitem === void 0 ? void 0 : (_linkitem$children = linkitem.children) === null || _linkitem$children === void 0 ? void 0 : _linkitem$children.length) > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons secondary-dropdown-nav__arrow-icon secondary-dropdown-nav__arrow-icon--fourth",
        onClick: show,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 29
        }
      }, "arrow_right"), /*#__PURE__*/_react.default.createElement("div", {
        className: fourthLevelClass,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103,
          columnNumber: 29
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "secondary-dropdown-nav__submenu-back-navigation secondary-dropdown-nav__submenu-back-navigation-fourth",
        onClick: hide,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104,
          columnNumber: 33
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons secondary-dropdown-nav__submenu-back-arrow",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108,
          columnNumber: 37
        }
      }, "arrow_back")), /*#__PURE__*/_react.default.createElement("ul", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113,
          columnNumber: 33
        }
      }, /*#__PURE__*/_react.default.createElement("li", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114,
          columnNumber: 37
        }
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "secondary-dropdown-nav__submenu__link",
        "aria-label": linkitem === null || linkitem === void 0 ? void 0 : linkitem.title,
        href: linkitem === null || linkitem === void 0 ? void 0 : linkitem.url,
        target: linkitem === null || linkitem === void 0 ? void 0 : linkitem.target,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115,
          columnNumber: 41
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "secondary-dropdown-nav__submenu__link-text",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121,
          columnNumber: 45
        }
      }, linkitem === null || linkitem === void 0 ? void 0 : linkitem.title))), generateFourth(linkitem))))));
    });
    return array;
  }

  function generateFourth(items) {
    let array = [];
    items.children.forEach((fourthLevel, fourthIndex) => {
      array.push( /*#__PURE__*/_react.default.createElement("li", {
        key: fourthIndex,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 144,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "secondary-dropdown-nav__submenu__link",
        "aria-label": fourthLevel.title,
        href: fourthLevel.url,
        target: fourthLevel.target,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 145,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "secondary-dropdown-nav__submenu__link-text",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151,
          columnNumber: 25
        }
      }, fourthLevel.title))));
    });
    return array;
  }

  const secondaryMenu = () => {
    let secondLvlArray = [];
    props.secondaryLinkGroupList.forEach((items, secondLvlIndex) => {
      var _items$children;

      const expandThirdId = `${secondLvlIndex}-${items.title}`;
      const thirdLevelClass = (0, _classnames.default)('secondary-dropdown-nav__submenu', {
        'secondary-dropdown-nav__submenu--active': expandThirdId === thirdLevelToShow
      });

      function show() {
        setThirdLevelToShow(expandThirdId);
      }

      function hide() {
        setThirdLevelToShow('');
      }

      if ((items === null || items === void 0 ? void 0 : (_items$children = items.children) === null || _items$children === void 0 ? void 0 : _items$children.length) > 0) {
        secondLvlArray.push( /*#__PURE__*/_react.default.createElement("div", {
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 183,
            columnNumber: 21
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "secondary-dropdown-nav__secondary-group-label-unit",
          onClick: show,
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 184,
            columnNumber: 25
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "secondary-dropdown-nav__secondary-group-label-unit-text",
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 188,
            columnNumber: 29
          }
        }, items.title), /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icons secondary-dropdown-nav__arrow-icon",
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 189,
            columnNumber: 29
          }
        }, "arrow_right")), /*#__PURE__*/_react.default.createElement("div", {
          className: thirdLevelClass,
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 193,
            columnNumber: 25
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "secondary-dropdown-nav__submenu-back-navigation",
          onClick: hide,
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 194,
            columnNumber: 29
          }
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons secondary-dropdown-nav__submenu-back-arrow",
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 198,
            columnNumber: 33
          }
        }, "arrow_back")), /*#__PURE__*/_react.default.createElement("ul", {
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 203,
            columnNumber: 29
          }
        }, generateThird(items, expandThirdId)))));
      } else {
        secondLvlArray.push( /*#__PURE__*/_react.default.createElement("a", {
          href: items.url,
          target: items.target,
          className: "secondary-dropdown-nav__secondary-group-label-unit",
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 211,
            columnNumber: 21
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "secondary-dropdown-nav__secondary-group-label-unit-text",
          __self: void 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 216,
            columnNumber: 25
          }
        }, items.title)));
      }
    });
    return secondLvlArray;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-nav",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 228,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "secondary-dropdown-nav",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 229,
      columnNumber: 13
    }
  }, (props === null || props === void 0 ? void 0 : (_props$header = props.header) === null || _props$header === void 0 ? void 0 : _props$header.loginLink) && (props === null || props === void 0 ? void 0 : (_props$header2 = props.header) === null || _props$header2 === void 0 ? void 0 : _props$header2.signInLabel) && (props === null || props === void 0 ? void 0 : (_props$header3 = props.header) === null || _props$header3 === void 0 ? void 0 : _props$header3.isLoggedIn) === false && /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-nav__sign-in-ctn",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
    to: props.header.loginLink,
    className: "SigninButton",
    target: '_parent',
    onClick: e => {
      var _props$trackClick5;

      return props === null || props === void 0 ? void 0 : (_props$trackClick5 = props.trackClick) === null || _props$trackClick5 === void 0 ? void 0 : _props$trackClick5.call(props, e);
    },
    onAuxClick: e => {
      var _props$trackClick6;

      return props === null || props === void 0 ? void 0 : (_props$trackClick6 = props.trackClick) === null || _props$trackClick6 === void 0 ? void 0 : _props$trackClick6.call(props, e);
    },
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "dropdown-nav__sign-in-btn",
    "aria-label": "Login",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 239,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown-nav__sign-in-text",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 240,
      columnNumber: 33
    }
  }, props.header.signInLabel)))), ((props === null || props === void 0 ? void 0 : props.SigninButton) || (props === null || props === void 0 ? void 0 : props.SignoutButton)) && (props === null || props === void 0 ? void 0 : props.secondaryNavSource) === 'ecom' && /*#__PURE__*/_react.default.createElement("ul", {
    className: `dropdown-nav__ecom-container ${props !== null && props !== void 0 && (_props$header4 = props.header) !== null && _props$header4 !== void 0 && _props$header4.isAuthenticated ? 'userLoggedIn' : 'notLoggedIn'} `,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-nav__ecom-column no-border",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 249,
      columnNumber: 25
    }
  }, props === null || props === void 0 ? void 0 : props.SigninButton, props === null || props === void 0 ? void 0 : props.SignoutButton)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("dropdown-nav__search-ctn", {
      "dropdown-nav__search-ctn--hide": !(props !== null && props !== void 0 && props.showSearch)
    }),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 261,
      columnNumber: 17
    }
  }, (_props$SearchForm = props === null || props === void 0 ? void 0 : props.SearchForm) !== null && _props$SearchForm !== void 0 ? _props$SearchForm : /*#__PURE__*/_react.default.createElement("form", {
    className: "Header-container-secondary__text-field--form-mobile",
    id: "Header-container-secondary__text-field-form-mobile",
    onSubmit: props === null || props === void 0 ? void 0 : props.searchSubmit,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 265,
      columnNumber: 25
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "Header-container-secondary__text-field-input-mobile",
    className: "Header-container-secondary__text-field",
    placeholder: "Search products",
    name: "searchText",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 270,
      columnNumber: 29
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "material-icons Header-container-secondary__search-icon",
    type: "submit",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 276,
      columnNumber: 29
    }
  }, "search"))), /*#__PURE__*/_react.default.createElement("div", {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 285,
      columnNumber: 17
    }
  }, secondaryMenu())), props.isAuthenticated && isAuthMenu(), navLink(), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-nav__social-ctn",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 289,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
    to: props.header.facebookLink,
    target: '_blank',
    onClick: e => {
      var _props$trackClick7;

      return props === null || props === void 0 ? void 0 : (_props$trackClick7 = props.trackClick) === null || _props$trackClick7 === void 0 ? void 0 : _props$trackClick7.call(props, e);
    },
    onAuxClick: e => {
      var _props$trackClick8;

      return props === null || props === void 0 ? void 0 : (_props$trackClick8 = props.trackClick) === null || _props$trackClick8 === void 0 ? void 0 : _props$trackClick8.call(props, e);
    },
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 290,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "dropdown-nav__social-logo facebook",
    alt: "Facebook",
    src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : (_props$header5 = props.header) === null || _props$header5 === void 0 ? void 0 : _props$header5.facebookIcon),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 296,
      columnNumber: 21
    }
  })), /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
    to: props.header.linkedInLink,
    target: '_blank',
    onClick: e => {
      var _props$trackClick9;

      return props === null || props === void 0 ? void 0 : (_props$trackClick9 = props.trackClick) === null || _props$trackClick9 === void 0 ? void 0 : _props$trackClick9.call(props, e);
    },
    onAuxClick: e => {
      var _props$trackClick10;

      return props === null || props === void 0 ? void 0 : (_props$trackClick10 = props.trackClick) === null || _props$trackClick10 === void 0 ? void 0 : _props$trackClick10.call(props, e);
    },
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 302,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "dropdown-nav__social-logo facebook",
    alt: "LinkedIn",
    src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : (_props$header6 = props.header) === null || _props$header6 === void 0 ? void 0 : _props$header6.linkedInIcon),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 308,
      columnNumber: 21
    }
  })), /*#__PURE__*/_react.default.createElement(_pageLink.PageLink, {
    to: props.header.instagramLink,
    target: '_blank',
    onClick: e => {
      var _props$trackClick11;

      return props === null || props === void 0 ? void 0 : (_props$trackClick11 = props.trackClick) === null || _props$trackClick11 === void 0 ? void 0 : _props$trackClick11.call(props, e);
    },
    onAuxClick: e => {
      var _props$trackClick12;

      return props === null || props === void 0 ? void 0 : (_props$trackClick12 = props.trackClick) === null || _props$trackClick12 === void 0 ? void 0 : _props$trackClick12.call(props, e);
    },
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 314,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "dropdown-nav__social-logo facebook",
    alt: "Instagram",
    src: (0, _helpers.resolveAsset)(props === null || props === void 0 ? void 0 : (_props$header7 = props.header) === null || _props$header7 === void 0 ? void 0 : _props$header7.instagramIcon),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 320,
      columnNumber: 21
    }
  }))));
};

exports.DropdownNav = DropdownNav;
var _default = DropdownNav;
exports.default = _default;